export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  delay: number = 300
) => {
  let timer: NodeJS.Timeout;

  const debouncedFunction = (...args: Parameters<T>) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };

  return debouncedFunction as (...args: Parameters<T>) => ReturnType<T>;
};
